import { Grid } from "@mui/material";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";

interface Props {
  icon: React.ReactNode;
  title: string;
  primaryTextList: { primaryValue: string; primaryText: string }[];
  secondaryText: string;
  extraText?: string;
}

export function RateCard({ icon, title, primaryTextList, secondaryText, extraText }: Props) {
  return (
    <MDBox sx={{ padding: "1rem", borderRadius: "8px" }}>
      <Grid container item alignItems={"center"} gap={1} mb={1}>
        {icon}

        <MDTypography variant="h6" fontWeight="bold">
          {title}
        </MDTypography>
      </Grid>

      {extraText && (
        <MDBox mb={1}>
          <MDTypography variant="caption" color="text" fontWeight="bold" marginTop={2}>
            {extraText}
          </MDTypography>
        </MDBox>
      )}

      {primaryTextList.map(({ primaryValue, primaryText }, index) => (
        <Grid container item key={index}>
          <MDTypography variant="caption" fontWeight="bold" color="dark" display="inline">
            {primaryValue} &nbsp;
          </MDTypography>
          <MDTypography variant="caption" fontWeight="bold" color="text" display="inline">
            {primaryText}
          </MDTypography>
        </Grid>
      ))}

      <MDBox mt={0.5}>
        <MDTypography variant="caption" color="text">
          {secondaryText}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
